import { PureComponent } from "react";
import { createFragmentContainer, graphql } from "react-relay";
import classNames from "classnames";

type Props = {
  metric: any;
};

class Metric extends PureComponent<Props> {
  render() {
    if (!this.props.metric) {
      return null;
    }

    return (
      <a
        href={this.props.metric.url}
        className="color-inherit flex flex-col no-underline"
        style={{ width: "7em" }}
      >
        <span className="dark-gray max-w-full truncate text-xs font-normal">
          {this.props.metric.label}
        </span>
        {this.renderValue()}
      </a>
    );
  }

  renderValue() {
    const match = String(this.props.metric.value).match(/([\d.]+)(.*)/);
    const valueClasses = "text-2xl m-0 leading-none medium";

    if (match) {
      return (
        <span className="max-w-full truncate">
          <span className={valueClasses}>{match[1]}</span>
          <span className="dark-gray m-0 text-xs font-normal leading-none">{match[2]}</span>
        </span>
      );
    } else if (this.props.metric.value) {
      return (
        <span className={classNames(valueClasses, "max-w-full truncate")}>
          {this.props.metric.value}
        </span>
      );
    }

    return <span className={classNames(valueClasses, "gray")}>-</span>;
  }
}

export default createFragmentContainer(Metric, {
  metric: graphql`
    fragment Metric_metric on PipelineMetric {
      label
      value
      url
    }
  `,
});
